import {
  SuppliersListingActions,
  SuppliersListingGetters,
  SuppliersListingMutations
} from '@/app/features/suppliers/features/suppliers-listing/suppliers-listing.keys';

import { suppliersListingService as suppliersService } from '@/app/features/suppliers/features/suppliers-listing/suppliers-listing.service';

import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';

import i18n from '@/i18n';

export const getInitialState = () => {
  return {
    suppliers: [],
    suppliersRecordCount: 0,
    suppliersSortOrder: {
      sortBy: 'name',
      sortDirection: 'asc'
    },
    suppliersPaginationParameters: {
      recordsPerPage: 10,
      offset: 0
    },
    suppliersActiveInactive: 'both',
    supplierSearchParam: ''
  };
};

export const suppliersListingStore = {
  state: getInitialState(),
  getters: {
    [SuppliersListingGetters.SuppliersList]: state => state.suppliers,
    [SuppliersListingGetters.SortBy]: state => state.suppliersSortOrder.sortBy,
    [SuppliersListingGetters.SortDirection]: state => state.suppliersSortOrder.sortDirection,
    [SuppliersListingGetters.SuppliersPerPage]: state =>
      state.suppliersPaginationParameters.recordsPerPage,
    [SuppliersListingGetters.SupplierListingOffset]: state =>
      state.suppliersPaginationParameters.offset,
    [SuppliersListingGetters.SuppliersRecordCount]: state => state.suppliersRecordCount,
    [SuppliersListingGetters.SuppliersActiveInactive]: state => state.suppliersActiveInactive,
    [SuppliersListingGetters.SupplierSearchParam]: state => state.supplierSearchParam
  },
  mutations: {
    [SuppliersListingMutations.SetSuppliersList](state, suppliers) {
      state.suppliers = suppliers;
    },
    [SuppliersListingMutations.SetSuppliersSortOrder](state, sortOrder) {
      state.suppliersSortOrder = sortOrder;
    },
    [SuppliersListingMutations.SetSuppliersPaginationParameters](state, pagination) {
      state.suppliersPaginationParameters = pagination;
    },
    [SuppliersListingMutations.ResetSuppliersPaginationOffset](state) {
      state.suppliersPaginationParameters.offset = 0;
    },
    [SuppliersListingMutations.SetSuppliersRecordCount](state, recordCount) {
      state.suppliersRecordCount = recordCount;
    },
    [SuppliersListingMutations.SetSuppliersActiveInactive](state, activeInactive) {
      state.suppliersActiveInactive = activeInactive;
    },
    [SuppliersListingMutations.SetSuppliersSearchParam](state, param) {
      state.supplierSearchParam = param;
    }
  },
  actions: {
    [SuppliersListingActions.RetrieveSuppliersList]({ state, commit, dispatch }) {
      return suppliersService
        .retrieveSuppliersList(
          state.suppliersActiveInactive,
          state.suppliersSortOrder,
          state.suppliersPaginationParameters
        )
        .then(suppliers => {
          dispatch(SuppliersListingActions.RetrieveSuppliersRecordCount);
          commit(SuppliersListingMutations.SetSuppliersList, suppliers);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('suppliers.listing.errors.retrieveSuppliers')
          });
        });
    },
    [SuppliersListingActions.UpdateSuppliersSortOrder]({ commit, dispatch }, sortOrder) {
      commit(SuppliersListingMutations.SetSuppliersSortOrder, sortOrder);
      commit(SuppliersListingMutations.ResetSuppliersPaginationOffset);
      dispatch(SuppliersListingActions.RetrieveSuppliersList);
    },
    [SuppliersListingActions.UpdateSuppliersPaginationParameters](
      { commit, dispatch },
      pagination
    ) {
      commit(SuppliersListingMutations.SetSuppliersPaginationParameters, pagination);
      dispatch(SuppliersListingActions.RetrieveSuppliersList);
    },
    [SuppliersListingActions.UpdateSuppliersActiveInactive]({ commit, dispatch }, activeInactive) {
      commit(SuppliersListingMutations.SetSuppliersActiveInactive, activeInactive);
      dispatch(SuppliersListingActions.RetrieveSuppliersList);
    },

    [SuppliersListingActions.RetrieveSuppliersRecordCount]: ({ state, commit, dispatch }) => {
      return suppliersService
        .retrieveRecordCount(state.suppliersActiveInactive, state.supplierSearchParam)
        .then(res => {
          commit(SuppliersListingMutations.SetSuppliersRecordCount, res);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error
          });
        });
    },
    [SuppliersListingActions.DownloadSuppliersListAsExcel]({ state }, downloadPreference) {
      let suppliersPaginationParameters = '';
      if (downloadPreference === i18n.t('suppliers.listing.actions.exportPage')) {
        suppliersPaginationParameters = state.suppliersPaginationParameters;
      }
      suppliersService.downloadSuppliersXlsx(
        suppliersPaginationParameters,
        state.suppliersSortOrder,
        state.suppliersActiveInactive
      );
    },
    [SuppliersListingActions.UpdateSuppliersList]({ commit, dispatch }, searchResult) {
      commit(SuppliersListingMutations.SetSuppliersSearchParam, searchResult.searchParam);
      commit(SuppliersListingMutations.ResetSuppliersPaginationOffset);

      return dispatch(SuppliersListingActions.RetrieveSuppliersRecordCount).then(() => {
        commit(SuppliersListingMutations.SetSuppliersList, searchResult.data);
      });
    }
  }
};
